// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.0.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1659018607777';
export const BUILD_DATE = '2022-07-28T14:30:07.777Z';
/* tslint:enable */
